import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import ocsLogo from '../../assets/logos/ocslogoonly.png'
import './Navbar.css'

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [openDropdown, setOpenDropdown] = useState(null)
  const location = useLocation()
  const isHome = location.pathname === '/'

  const navItems = [
    {
      label: "RECRUITERS' CORNER",
      hasDropdown: true,
      links: [
        /* to for within react app, href for external */
        { label: "Recruiter's Portal", href: '/portal' },
        { label: "Why Recruit?", to: '/whyrecruit' },
        { label: "Achievements", to: '/whyrecruit/achievements' },
        { label: "Graduating Batch Profile", to: '/whyrecruit/demographics' },
        { label: "Department Brochures", to: '/whyrecruit/programs' },
        { label: "Japan Day", to: '/whyrecruit/japanday' },
        { label: "Career Connect 2026", to: '/whyrecruit/careerFair' },
        { label: "Research and Development", to: '/whyrecruit/rnd' },
        { label: "Extracurriculars", to: '/whyrecruit/extracurriculars' },
        // { label: '=X= Placement Brochure', href: '/IITH_PB_25-26.pdf' },
        { label: "Placement and Internship Brochures", to: '/whyrecruit/forms' },
        { label: "Recruiters Policy for Placements", to: '/whyrecruit/recruiterspolicy/placements' },
        { label: "Recruiters Policy for Internships", to: '/whyrecruit/recruiterspolicy/internships' },
        { label: "Recruiter's Portal Guide", to: '/whyrecruit/howto' },
      ]
    },
    {
      label: "STUDENTS' CORNER",
      hasDropdown: true,
      links: [
        { label: "Students' Corner (overview)", to: '/students' },
        { label: "Students' Portal", href: '/portal' },
        { label: "Placement Rules and Regulations", to: '/students/placementrules' },
        { label: "Internship Rules and Regulations", to: '/students/internrules' },
        { label: "Internship Guidelines for PG Students", to: '/students/internrulesforpg' },
        { label: "Placement Experiences", to: '/students/placement' },
        { label: "Internship Experiences", to: '/students/internship' },
        { label: "Placement Day", to: '/students/placementDay' },
        { label: "Webinars", href: '/login/student/portal/webinars' },
        { label: "Research Programs", to: '/careercell' },
        { label: "Credit Policy", href: '/static/media/Credit-Policy.bc10ecb6.pdf' },
        { label: "Student's Portal Guide", to: '/students/howto' },
        { label: "Linkedin Guide", to: '/students/linkedin' },
        { label: "Guide to Professional Correspondence", to: '/students/guidetoprocor' }
      ]
    },
    {
      label: 'REACH OUT TO IITH',
      hasDropdown: false,
      to: '/reachus'
    },
    {
      label: 'CONTACT US',
      hasDropdown: false,
      to: '/about'
    },
    {
      label: 'INTERNSHIP & PLACEMENT PORTAL',
      hasDropdown: false,
      href: '/portal'
    },
  ]

  return (
    <nav className={`navbar ${isHome ? 'navbar-pill-style' : 'navbar-transparent'}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-brand" onClick={() => setMenuOpen(false)}>
          <img src={ocsLogo} alt="OCS" />
          <span className="brand-text">OCS IITH</span>
        </Link>

        <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          <span className={`hamburger ${menuOpen ? 'open' : ''}`}></span>
        </button>

        <ul className="navbar-menu">
          {navItems.map((item, idx) => (
            <li 
              key={item.label} 
              className={`nav-item ${item.hasDropdown ? 'has-dropdown' : ''}`}
              onMouseEnter={() => item.hasDropdown && setOpenDropdown(idx)}
              onMouseLeave={() => item.hasDropdown && setOpenDropdown(null)}
            >
              {item.hasDropdown ? (
                <>
                  <button className="nav-link dropdown-toggle">
                    {item.label}
                    <svg className="chevron" width="10" height="6" viewBox="0 0 10 6" fill="none">
                      <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <ul className={`dropdown-menu ${openDropdown === idx ? 'show' : ''}`}>
                    {item.links.map((link) => (
                      <li key={link.label}>
                        {link.to ? (
                          <Link to={link.to} className="dropdown-link" onClick={() => setMenuOpen(false)}>{link.label}</Link>
                        ) : (
                          <a href={link.href} className="dropdown-link" target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)}>{link.label}</a>
                        )}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link to={item.to} className="nav-link">{item.label}</Link>
              )}
            </li>
          ))}
        </ul>
      </div>

      {/* Side Menu */}
      <div className={`side-menu-overlay ${menuOpen ? 'show' : ''}`} onClick={() => setMenuOpen(false)}></div>
      <div className={`side-menu ${menuOpen ? 'show' : ''}`}>
        <div className="side-menu-header">
          <Link to="/" className="side-brand" onClick={() => setMenuOpen(false)}>
            <img src={ocsLogo} alt="OCS" />
            <span>OCS</span>
          </Link>
          <button className="side-close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <ul className="side-menu-list">
          {navItems.map((item) => (
            <li key={item.label} className="side-item">
              {item.hasDropdown ? (
                <>
                  <span className="side-label">{item.label}</span>
                  <ul className="side-submenu">
                    {item.links.map((link) => (
                      <li key={link.label}>
                        {link.to ? (
                          <Link to={link.to} className="side-sublink" onClick={() => setMenuOpen(false)}>{link.label}</Link>
                        ) : (
                          <a href={link.href} className="side-sublink" target="_blank" rel="noreferrer" onClick={() => setMenuOpen(false)}>{link.label}</a>
                        )}
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link to={item.to} className="side-link" onClick={() => setMenuOpen(false)}>{item.label}</Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  )
}